export default __webpack_public_path__ + "static/mapError-b28bc15a44c8c277c4e549f7e5007bcf.jpg";